import _ from 'lodash';
import sha1 from 'sha1';

import { getDate, stringToHourFormat } from './dates';
import { TimeplanUnitRecord } from '../entities/records';

const generateTimeplanUnitId = () => sha1(Math.random());

/**
 * @deprecated Should be a Record
 */
export function createTimeplanUnit(id, date, resourceId, workType, from, to) {
  return new TimeplanUnitRecord(_.omitBy({
    id,
    date: date ? getDate(date) : undefined,
    resourceId,
    workType,
    from: from ? stringToHourFormat(from) : undefined,
    to: to ? stringToHourFormat(to) : undefined,
  }, _.isNil));
}

export function createNewTimeplanUnit(date, resourceId, workType, from, to) {
  const id = generateTimeplanUnitId();
  return createTimeplanUnit(id, date, resourceId, workType, from, to);
}

export function copyTimeplanUnit(timeplanUnit) {
  return timeplanUnit.set('id', generateTimeplanUnitId());
}
